<ng-content *ngIf="!isLoading && !error" class="wz-container animated fadeIn">
</ng-content>
<wz-content-loader *ngIf="isLoading && !error" [isCard]="false"
  >{{ loadingText || 'Chargement des données' }}
</wz-content-loader>
<wz-error-viewer matIcon="warning" *ngIf="error && !errorTemplate">{{
  error | wzError
}}</wz-error-viewer>
<ng-content *ngIf="error" select="[wzAsyncContentError]"></ng-content>
